import React from "react";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";
import Container from "@material-ui/core/Container";
import CssBaseline from "@material-ui/core/CssBaseline";
import Header from "components/Header";
import ErrorBoundary from "components/ErrorBoundary";
import useStyles from "./styles";

interface IProps {
	children: React.ReactNode;
}

export default function Layout(props: IProps) {
	const classes = useStyles();
	const { children } = props;

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Header />
			<Container maxWidth="xl" className={classes.content}>
				<div className={classes.toolbar} />
				<Hidden smDown>
					<Box display="flex" alignContent="center" pb={2}></Box>
				</Hidden>
				<ErrorBoundary>{children}</ErrorBoundary>
			</Container>
		</div>
	);
}
